import { Fragment } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { C, tbl } from "../reporting/reportingStyles";
import { Badge } from "../reporting/ReportingShared";

const headerStyle = { borderBottom: `2px solid ${C.borderLight}`, fontFamily: "'Inter', sans-serif" };
const bodyStyle = { padding: 20, fontFamily: "'Inter', sans-serif", maxHeight: "65vh", overflowY: "auto" };
const footerStyle = { borderTop: `1px solid ${C.borderLight}`, gap: 8 };
const coralBtnStyle = { background: C.coral, border: "none", borderRadius: 10, fontWeight: 600, fontSize: 13 };
const ghostBtnStyle = { background: C.bg, border: `1px solid ${C.border}`, color: C.text, borderRadius: 10, fontWeight: 600, fontSize: 13 };
const DANGER = "#b42318";
const DANGER_BG = "#FEF3F2";

const KIND_BADGE = {
  change: { color: C.coral, bg: C.coralLight },
  new: { color: C.green, bg: C.greenLight },
  remove: { color: DANGER, bg: DANGER_BG },
};

// Save gate for the Edit Merchant form: lists every change (old → new) and only
// submits after the admin confirms. Rows come from buildMerchantChanges.
const MerchantChangesReviewModal = ({ isOpen, toggle, rows, saving, onConfirm }) => {
  const sections = [];
  rows.forEach((row) => {
    let group = sections.find((s) => s.name === row.section);
    if (!group) {
      group = { name: row.section, sensitive: row.sensitive, rows: [] };
      sections.push(group);
    }
    group.rows.push(row);
  });
  const removals = rows.filter((r) => r.kind === "remove").length;

  return (
    <Modal isOpen={isOpen} toggle={saving ? undefined : toggle} size="lg" centered>
      <ModalHeader toggle={saving ? undefined : toggle} style={headerStyle}>
        Review {rows.length} change{rows.length === 1 ? "" : "s"}
      </ModalHeader>
      <ModalBody style={bodyStyle}>
        <div style={{ fontSize: 12, color: C.textMed, marginBottom: 14 }}>
          Nothing has been saved yet. Check each change below, then confirm.
          {removals > 0 && (
            <span style={{ color: DANGER, fontWeight: 600 }}>
              {" "}{removals} value{removals === 1 ? "" : "s"} will be removed.
            </span>
          )}
        </div>
        <table style={tbl.table}>
          <thead>
            <tr>
              {["Field", "Current", "New"].map((h) => (
                <th key={h} style={tbl.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sections.map((section) => (
              <Fragment key={section.name}>
                <tr>
                  <td colSpan={3} style={{ ...tbl.td, background: C.bg, fontWeight: 700, fontSize: 12, color: C.text }}>
                    {section.name}
                    {section.sensitive && (
                      <span style={{ marginLeft: 8 }}>
                        <Badge color={C.orange} bg={C.orangeLight}>Sensitive</Badge>
                      </span>
                    )}
                  </td>
                </tr>
                {section.rows.map((row) => {
                  const badge = KIND_BADGE[row.kind] || KIND_BADGE.change;
                  return (
                    <tr key={`${section.name}-${row.label}`}>
                      <td style={{ ...tbl.td, fontWeight: 600, color: C.text }}>{row.label}</td>
                      <td style={{ ...tbl.td, color: C.textMed, wordBreak: "break-word" }}>{row.from}</td>
                      <td style={{ ...tbl.td, wordBreak: "break-word" }}>
                        <Badge color={badge.color} bg={badge.bg}>{row.to}</Badge>
                        {row.note && (
                          <div style={{ fontSize: 11, color: DANGER, marginTop: 6, lineHeight: 1.4 }}>{row.note}</div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </Fragment>
            ))}
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter style={footerStyle}>
        <Button type="button" onClick={toggle} disabled={saving} style={ghostBtnStyle}>
          Back to editing
        </Button>
        <Button type="button" onClick={onConfirm} disabled={saving} style={coralBtnStyle}>
          {saving ? "Saving…" : "Confirm & Save"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MerchantChangesReviewModal;
